var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisacard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#39444F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3747_91961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9833 9.07648C13.5835 9.07648 12.3326 9.80119 12.3326 11.1401C12.3326 12.6757 14.5511 12.7817 14.5511 13.5531C14.5511 13.878 14.1785 14.1687 13.542 14.1687C12.6388 14.1687 11.9637 13.7624 11.9637 13.7624L11.6748 15.1136C11.6748 15.1136 12.4525 15.4568 13.485 15.4568C15.0154 15.4568 16.2196 14.6965 16.2196 13.3346C16.2196 11.7121 13.9919 11.6091 13.9919 10.8932C13.9919 10.6387 14.2978 10.3599 14.9324 10.3599C15.6485 10.3599 16.2327 10.6554 16.2327 10.6554L16.5154 9.3504C16.5154 9.3504 15.8797 9.07648 14.9833 9.07648ZM2.17696 9.17497L2.14307 9.37195C2.14307 9.37195 2.73194 9.4796 3.26232 9.69435C3.94522 9.9406 3.99387 10.0839 4.10888 10.5292L5.36216 15.3552H7.04219L9.63041 9.17497H7.95423L6.29115 13.3769L5.61251 9.81515C5.55028 9.40751 5.23502 9.17497 4.84914 9.17497H2.17696ZM10.3044 9.17497L8.98952 15.3552H10.5879L11.8982 9.17497H10.3044ZM19.2191 9.17497C18.8337 9.17497 18.6295 9.38109 18.4797 9.74128L16.1379 15.3552H17.8141L18.1384 14.4195H20.1805L20.3777 15.3552H21.8567L20.5664 9.17497H19.2191ZM19.4371 10.8447L19.934 13.1638H18.6029L19.4371 10.8447Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3747_91961"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.1333,
    y: 9.06662,
    width: 19.7333,
    height: 6.4,
    rx: 2,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacard);
export default __webpack_public_path__ + "static/media/visacard.2751e023.svg";
export { ForwardRef as ReactComponent };